import { render, staticRenderFns } from "./WhatNeedsPaintingFormStep.vue?vue&type=template&id=620dcbc8"
import script from "./WhatNeedsPaintingFormStep.vue?vue&type=script&lang=js"
export * from "./WhatNeedsPaintingFormStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports